import React from 'react';
import './ClickEffect.css';

interface ClickEffectProps {
    x: number;
    y: number;
}

export const ClickEffect: React.FC<ClickEffectProps> = ({ x, y }) => {
    return <div className="click-effect" style={{ top: y, left: x }} />;
};
